module.exports = __webpack_public_path__ + "img/美容水(蓝)_04.71789dc2.jpg";